import React from 'react';

const ClockArrowDownIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M12 6v6l2 1"/>
            <path d="M12.337 21.994a10 10 0 1 1 9.588-8.767"/>
            <path d="m14 18 4 4 4-4"/>
            <path d="M18 14v8"/>
        </svg>
    );
};

export default ClockArrowDownIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ClockArrowDownIcon.jsx